<div id="titulo">
    <h2>Taller preferente por CP</h2>
    <h2 id="btnCerrar" mat-flat-button (click)="onClose()" style="margin-right: 20px;" >X</h2>
</div>
<div style="display: block;" id="containerCompleto">
    <div id="borderContainer" >
        <div  style="display: flex;">
            <div class="campo">
                <label><b>Servicio recogida y entrega</b>/ Si tiene servicio de recogida informar la dirección </label>
                <mat-select style="min-width: 0;width: 50px;margin-left: 15%;">
                    <mat-option value="s">Si</mat-option>
                    <mat-option value="n">No</mat-option>
                </mat-select>
            </div>
        </div>        
        <div class="campo">
            <label>Dirección de recogida</label>
            <input type="text"matInput>
        </div>
        <div style="display: flex;gap: 10px;">
            <div class="campo">
                <label>Población de recogida</label>
                <input type="text"matInput>        
            </div>
            <div class="campo">
                <label>C.P. de recogida</label>
                <input type="text"matInput>
            </div>
        </div>
        
    </div>
    <div style="display: flex;gap: 10px;">
        <div class="campo">
            <label>C.P.</label>
            <input type="text"matInput [(ngModel)]="data.cp" >
        </div>
        <div class="campo">
            <label>Población</label>
            <input type="text"matInput>
        </div>
        <div class="campo">
            <label>Provincia</label>
            <input type="text"matInput>
        </div>
    </div>
    <!--displayedColumns: string[] = ['n', 'nombre', 'direccion', 'poblacion','telefono','email'];-->
    <div id="talleresContainer">
        <table mat-table class="tabla-art" [dataSource]="dataSource"  style="min-width: auto; font-family: 'Exo 2 Regular', sans-serif; font-size: 17px; letter-spacing: 0;">
            <ng-container matColumnDef="clickable">
                <th mat-header-cell *matHeaderCellDef style="background:white;"></th>
                <td mat-cell *matCellDef="let element" (click)="volcarSeleccion(element)"></td>
              </ng-container>
            <ng-container matColumnDef="n">
            <th mat-header-cell *matHeaderCellDef style="background: white;">Nº</th>
            <td mat-cell *matCellDef="let element"> {{element.n}} </td>
            </ng-container>
            <ng-container matColumnDef="nombre">
                <th mat-header-cell *matHeaderCellDef style="background: white;">Taller</th>
                <td mat-cell *matCellDef="let element"> {{element.nombre}} </td>
            </ng-container>
            <ng-container matColumnDef="direccion">
                <th mat-header-cell *matHeaderCellDef style="background: white;">Dirección</th>
                <td mat-cell *matCellDef="let element"> {{element.direccion}} </td>
            </ng-container>
            <ng-container matColumnDef="poblacion">
                <th mat-header-cell *matHeaderCellDef style="background: white;">Población</th>
                <td mat-cell *matCellDef="let element"> {{element.poblacion}} </td>
            </ng-container>
            <ng-container matColumnDef="telefono">
                <th mat-header-cell *matHeaderCellDef style="background: white;">Teléfono</th>
                <td mat-cell *matCellDef="let element"> {{element.telefono}} </td>
            </ng-container>
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef style="background: white;">Email</th>
                <td mat-cell *matCellDef="let element"> {{element.email}} </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>            
        </table>
    </div>
</div>